import { getAuthToken } from "../utils/index.js";
import { ROUTES } from "./names.js";
import { initAuth0, loginWithAuth0 } from "../composables/auth0.js";
import { AUTH_STORAGE_KEYS } from "../constants/auth.js";

export const isPrivateOnly = async (to, from, next) => {
  // If landing with Auth0 authorization code, let callback route/handler process it
  if (
    typeof window !== "undefined" &&
    window.location.search.includes("code=") &&
    window.location.search.includes("state=")
  ) {
    return next({ name: ROUTES.CALLBACK.name });
  }

  // Ensure Auth0 client is initialized before guard checks
  try {
    await initAuth0();
  } catch (err) {
    console.error("Failed to initialize Auth0 in isPrivateOnly guard:", err);
  }

  const token = getAuthToken();
  const isInvalidToken =
    !token ||
    token.toLowerCase() === "na" ||
    token === "undefined" ||
    token === "null";

  if (isInvalidToken) {
    await loginWithAuth0();
    return next(false);
  }

  next();
};

export const isPublicOnly = (to, from, next) => {
  const token = getAuthToken();
  const isValidToken =
    token &&
    token.toLowerCase() !== "na" &&
    token !== "undefined" &&
    token !== "null";

  if (isValidToken) {
    return next({ name: ROUTES.PROXIMA_PROFILES.name });
  }
  next();
};

export const redirectToNewSignin = async (to, from, next) => {
  // If landing with Auth0 authorization code, route to callback handler
  if (
    typeof window !== "undefined" &&
    window.location.search.includes("code=") &&
    window.location.search.includes("state=")
  ) {
    return next({ name: ROUTES.CALLBACK.name });
  }

  const token = getAuthToken();
  const isValidToken =
    token &&
    token.toLowerCase() !== "na" &&
    token !== "undefined" &&
    token !== "null";

  if (isValidToken) {
    return next({ name: ROUTES.PROXIMA_PROFILES.name });
  }

  await loginWithAuth0();
  return next(false);
};

// reference: https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
export const applyMetadata = (to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  else if (previousNearestWithMeta)
    document.title = previousNearestWithMeta.meta.title;

  const alias = "custom-metadata";
  Array.from(document.querySelectorAll(`[${alias}]`)).map((el) =>
    el.parentNode.removeChild(el)
  );

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute(alias, "");

      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));

  next();
};
